import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyCTuL_iNazt5GsyyEiN4rv6Yv3oQ4ypJuA",
  authDomain: "superagrodigital-ecf97.firebaseapp.com",
  projectId: "superagrodigital-ecf97",
  storageBucket: "superagrodigital-ecf97.firebasestorage.app",
  messagingSenderId: "864718464412",
  appId: "1:864718464412:web:2de16c9cbbdf15df219459",
  measurementId: "G-99R7QWZLN8",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

var storage = firebase.storage();

export default storage;
